import type { FC } from "react"

interface Props {
  className?: string
}

const Close: FC<Props> = ({ className }) => {
  return (
    <svg
      viewBox="0 0 13 14"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <rect
          id="path-1"
          x="0.443548387"
          y="0.822580645"
          width="375"
          height="718"
        ></rect>
      </defs>
      <g
        id="Mobile"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Menu-Copy-2" transform="translate(-26.000000, -23.000000)">
          <g id="Shapes" transform="translate(-1.000000, -1.000000)">
            <g id="Group-6" transform="translate(0.556452, 0.177419)">
              <mask id="mask-2" fill="white">
                <use xlinkHref="#path-1"></use>
              </mask>
              <g
                mask="url(#mask-2)"
                fill="currentColor"
                id="Fill-2"
                opacity="0.143484933"
              >
                <g transform="translate(-180.000000, -102.000000)">
                  <path
                    d="M409.3767,148.20751 C400.429181,144.751633 392.312129,147.301764 383.370474,145.802978 C374.004709,144.233461 372.271659,138.996775 364.637091,134.62168 C350.393417,126.459414 331.909337,135.265422 317.208812,138.290211 C305.825535,140.632304 294.480382,145.158824 289.202159,133.40963 C286.573182,127.565129 288.934614,121.53977 284.860183,115.628256 C280.190687,108.853601 272.871949,106.721782 265.068809,106.058414 C246.426755,104.470453 207.996232,124.585883 194.458689,108.06972 C180.081898,90.5313326 200.67611,52.8296764 165.265829,51.8137669 C140.234308,51.095134 114.645739,71.3872876 94.8625662,84.0590202 C67.6567156,101.489542 40.4249529,121.029202 17.0483905,143.460071 C-7.97007706,167.46656 21.0333202,168.8905 42.1144842,168.624747 C85.3519867,168.079564 128.843615,170.210442 172.135602,170.166716 C220.589851,170.119505 269.041521,170.687328 317.477164,170.563214 C343.110062,170.498773 368.658131,171.204691 394.261442,170.369746 C400.666901,170.163941 408.444321,169.132584 413.027442,163.604744 C417.694566,157.976732 415.859652,150.710968 409.3767,148.20751"
                    transform="translate(211.504570, 111.288048) scale(1, -1) rotate(-10.000000) translate(-211.504570, -111.288048) "
                  ></path>
                </g>
              </g>
            </g>
          </g>
          <g
            id="Group-4"
            transform="translate(27.000000, 24.500000)"
            fillRule="nonzero"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          >
            <line x1="0" y1="0" x2="11" y2="11" id="Path-2"></line>
            <line
              x1="0"
              y1="0"
              x2="11"
              y2="11"
              id="Path-2-Copy"
              transform="translate(5.500000, 5.500000) scale(-1, 1) translate(-5.500000, -5.500000) "
            ></line>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Close
